export const getPinnedFiles = (state) =>
  state.userSettings.pinnedFiles.reduce((acc, id) => {
    if (state.files.fileObjects[id]) acc.push(state.files.fileObjects[id]);
    return acc;
  }, []);
